import { render, staticRenderFns } from "./ProjetosClube.vue?vue&type=template&id=0a03c8c8"
import script from "./ProjetosClube.vue?vue&type=script&lang=ts"
export * from "./ProjetosClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports